// TUT-505 — a consulta normativa do escritório: só leitura (`GET
// /normative-lookup`). Não existe método de escrita: quem grava norma é o
// comando `db:import-normative`, fora da requisição.
//
// O demo vem DIRETO de `../demo/normas`, e não pelo `demoApi`: o
// `demo-data.ts` está no teto da catraca de tamanho e não tem folga nem para
// duas linhas. O `useDemoApi` é lido aqui (o empacotador só dobra a constante
// no módulo que a escreve), e a trava do bundle reprova se o demo vazar.
import { consultaNormativaDoDemo } from "../demo/normas";
import type { ConsultaNormativa, PedidoDeConsultaNormativa } from "../types";
import { request } from "./infra";

const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDasNormas = {
  consultaNormativa(pedido: PedidoDeConsultaNormativa): Promise<ConsultaNormativa> {
    if (useDemoApi) return consultaNormativaDoDemo(pedido);
    const params = new URLSearchParams();
    if (pedido.q) params.set("q", pedido.q);
    for (const catalogo of pedido.catalogo ?? []) params.append("catalogo", catalogo);
    if (pedido.norma) params.set("norma", pedido.norma);
    if (pedido.edicoes === "todas") params.set("edicoes", "todas");
    const consulta = params.toString();
    return request<ConsultaNormativa>(`/normative-lookup${consulta ? `?${consulta}` : ""}`);
  },
};
